import PaymentCDActionTypes from './paymentCD.types';

const INITIAL_STATE = {
  paymentConfirmList: [],
  paymentCDList: [],
  paymentEditInfo: null,
  paymentEditIndex: null,
  paymentAmount: 0,
  selectedCifId: ''
};

const paymentCDReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case PaymentCDActionTypes.SET_PAYMENT_CONFIRM_LIST:
      return {
        ...state,
        paymentConfirmList: [...state.paymentConfirmList, action.payload]
      };
    case PaymentCDActionTypes.SET_PAYMENT_AMOUNT:
      return {
        ...state,
        paymentAmount: action.payload
      };
    case PaymentCDActionTypes.CLEAR_PAYMENT_CONFIRM_LIST:
      return {
        ...state,
        paymentConfirmList: []
      };
    case PaymentCDActionTypes.SET_PAYMENT_CD_LIST:
      return {
        ...state,
        paymentCDList: action.payload
      };
    case PaymentCDActionTypes.SET_EDIT_PAYMENT_INFO:
      return {
        ...state,
        paymentEditInfo: action.payload
      };
    case PaymentCDActionTypes.SET_EDIT_PAYMENT_INDEX:
      return {
        ...state,
        paymentEditIndex: action.payload
      };
    case PaymentCDActionTypes.EDIT_PAYMENT_CD_LIST:
      return {
        ...state,
        paymentConfirmList: state.paymentConfirmList.map((content, index) =>
          index === action.index ? action.payload : content
        )
      };
    case PaymentCDActionTypes.DELETE_PAYMENT_CONFIRM_LIST:
      return {
        ...state,
        paymentConfirmList: [
          ...state.paymentConfirmList.slice(0, action.payload),
          ...state.paymentConfirmList.slice(action.payload + 1)
        ]
      };
    case PaymentCDActionTypes.SET_SELECTED_CIF_ID:
      return {
        ...state,
        selectedCifId: action.payload
      };
    case PaymentCDActionTypes.SET_DEFAULT_STATE:
      return {
        ...state,
        paymentConfirmList: [],
        paymentEditInfo: null,
        paymentEditIndex: null,
        paymentAmount: 0,
        selectedCifId: ''
      };
    default:
      return state;
  }
};

export default paymentCDReducer;
